import { render, staticRenderFns } from "./Product-detail.vue?vue&type=template&id=0c777bf8"
import script from "./Product-detail.vue?vue&type=script&lang=js"
export * from "./Product-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports